import { getNumberOfHuman, getNumberOfStations } from './station';

// Returns the timeslot and party room data with generalized naming conventions
// so that it can be passed to the ItemSelection component
export function getGeneralizedItems(state, languageObj) {
  const partyRoomsData = state.partyRoomsData;
  if (partyRoomsData) {
    let timeslots = {};
    let items = {};
    partyRoomsData.timeslots.forEach(timeslot => {
      timeslots[timeslot.timeslotId] = {
        timeslotId: timeslot.timeslotId,
        displayDayBefore: timeslot.displayDayBefore,
        time: timeslot.time,
        moment: timeslot.moment,
        utc_moment: timeslot.utc_moment,
        availableItems: timeslot.availablePartyRooms,
        itemIds: timeslot.partyRoomIds,
        itemAvailable: timeslot.partyRoomAvailable
      };
    });
    Object.keys(partyRoomsData.partyRooms).forEach(partyRoomId => {
      const partyRoom = partyRoomsData.partyRooms[partyRoomId];
      if (partyRoom !== undefined) {
        items[partyRoomId] = {
          itemId: parseInt(partyRoomId, 10),
          price: partyRoom.price,
          title: partyRoom.title,
          description: partyRoom.description,
          disabledDescription: languageObj.disabled_description_pre + partyRoom.minimumStations + languageObj.disabled_description_post,
          helpText: partyRoom.helpText,
          discounts: []
        };
      }
    });
    return {
      timeslots,
      items
    };
  }
  return {
    timeslots: {},
    items: {}
  };
}

// Returns whether or not any party rooms are available for the selected timeslots
export function getPartyRoomsAreAvailable(state) {
  let availableRooms = false;
  const partyRoomsData = state.partyRoomsData;
  
  if (partyRoomsData) {
    partyRoomsData.timeslots.forEach(timeslot => {
      timeslot.partyRoomIds.forEach((partyRoomId) => {
        if (timeslot.availablePartyRooms > 0) {
          availableRooms = true;
        }
      });
    });
  }
  return availableRooms;
}

export function getNumSelectedPartyRooms(state) {
  let numSelected = 0;
  Object.keys(state.selectedPartyRooms).forEach(timeslotId => {
    const timeslot = state.selectedPartyRooms[timeslotId];
    if (timeslot !== undefined) {
      Object.keys(timeslot).forEach(partyRoomId => {
        const quantity = timeslot[partyRoomId];
        numSelected += quantity || 0;
      });
    }
  });
  return numSelected;
}

// Determines if maximum occupancy is reached for any selected party rooms
export function getAnyOverCrowded(state, stationState) {
  let anyOverCrowded = false;
  const partyRoomData = state.partyRoomsData;
  if (partyRoomData) {
    partyRoomData.timeslots.forEach(timeslot => {
      const numPeople = getNumberOfHuman(stationState, timeslot.timeslotId);
      let capacitySum = 0;
      timeslot.partyRoomIds.forEach(partyRoomId => {
        const partyRoom = partyRoomData.partyRooms[partyRoomId];
        const capacity = partyRoom ? partyRoom.roomCapacity : 0;
        capacitySum += capacity;
      });
      if (numPeople > capacitySum) {
        anyOverCrowded = true;
      }
    });
  }
  return anyOverCrowded;
}

export function hasUnlockedPartyroom(state, stationState) {
  let unlockRooms = false;
  const partyRoomsData = state.partyRoomsData;
  if (partyRoomsData) {
    partyRoomsData.timeslots.forEach(timeslot => {
      timeslot.partyRoomIds.forEach((partyRoomId) => {
        if (partyRoomsData.partyRooms[partyRoomId].minimumStations <= getNumberOfStations(stationState, timeslot.timeslotId)) {
          unlockRooms = true;
        }
      });
    });
  }
  return unlockRooms;
}
